import { render } from "./BaseSwiper.vue?vue&type=template&id=0d90e196&scoped=true"
import script from "./BaseSwiper.vue?vue&type=script&lang=js"
export * from "./BaseSwiper.vue?vue&type=script&lang=js"

import "./BaseSwiper.vue?vue&type=style&index=0&id=0d90e196&scoped=true&lang=css"

import exportComponent from "/data0/www.sxsmdx.cn/src/ui/src-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d90e196"]])

export default __exports__